import { Injectable } from '@angular/core';
import { ExternalAction, ExternalActionData } from '../external.action.interface';
import { PlantService } from '@plants';
import { Router } from '@angular/router';
import { MessagesService, MessageType } from '@ui-messages';
import { __i18n } from '@localisation'

@Injectable()
export class DeletePlantActions implements ExternalAction {
    constructor(
        private plantService : PlantService,
        private router : Router,
        private messageService : MessagesService
    ){}

    public name : string = 'delete-plant';

    public async execute(data : ExternalActionData) {
        try {

            const result = await this.plantService.deletePlant(data.data.plantid);
            if(result){
                this.router.navigateByUrl('/Administration/Plants');
                this.messageService.addMessage({
                    text : __i18n('Plant successfully removed.', 'workflow.external.actions.plant.deleted.message.success'),
                    type : MessageType.success
                })
            }else{
                this.handleError();
            }
        }catch(e) {
            this.handleError();
            console.error('Error while deleting plant! [DeletePlantActions.execute]', e)
            //throw new Error("Error while deleting plantid!");
        }
    }

    private handleError(){
        this.messageService.addMessage({
            text : __i18n('Can not remove the plant!', 'workflow.external.actions.plant.deleted.message.error'),
            type : MessageType.error
        })
    }
}